import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Order } from "../models/order.model";
import { GraphQLService } from "./graphql.service";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class OrderService extends GraphQLService<Order> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  fetchOrder(builderhash: string): Observable<Order> {
    return this.push(`{ order(builderhash: "${ builderhash }") { id builderhash status totalprice shippingCost discountAmount paymentModule paymentProvider currency { currency } billingAddress { ${ this.addressFragment() } } shippingAddress {  ${ this.addressFragment() } } }}`)
  }

  performCheckout(base64Data: string): Observable<Order> {
    return this.push(`mutation { doCheckout(data: "${ base64Data }") { id builderhash paymentProvider paymentModule } }`)
  }

  private addressFragment() {
    return 'company firstname surname street postalCode city additional country { iso printableName }'
  }

}
